module.exports = __webpack_public_path__ + "static/sonia_video-b64966f36ac387504234f12407697f62.jpg";